export function IsMobileDevice() {
	// Use local storage instead of shared component state
	// because value must be available at application start
	const keyName = `isMobile`;
	const defaultValue = true;
	try {
		const storedValue = localStorage.getItem(keyName);
		if (storedValue === null) {
			localStorage.setItem(keyName, String(defaultValue));
			return defaultValue;
		}
		return storedValue === 'true';
	} catch {
		// Device hints are optional, including when browser storage is blocked.
		return defaultValue;
	}
}
